import axios from 'axios';
import state from './state'
import cache from './cache'
import { MessageBox } from 'element-ui';

let token = ''
    //添加请求拦截器
axios.interceptors.request.use(
    config => {
        //在发送请求之前做些什么
        token = localStorage.getItem("token")
            // console.log(state.ip)
        if (token != '') { // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = token;
            // config.headers.Authorization = '';
            // config.headers.Authorization = 'JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiMTAwMDEiLCJ1c2VybmFtZSI6IjE1MDcxMDU1NTAzIiwiZXhwIjoxNTY5MTIzOTk3fQ.4koyFrXcmIb2BJuXsNCqvVrV_ZkBPpz8qr9eLVXeMNg'
        }
        return config;
    },
    err => {
        //对响应错误做什么
        //console.log(err)
        return Promise.reject(err);
    })


//添加响应拦截器
axios.interceptors.response.use(
    response => {
        //console.log(111)
        return response
    },
    error => {
        console.log(error)
        if (error.response.status == 401) {
            //console.log(error.response.status)
            MessageBox.alert('登录信息超时，请重新登录！', '登录超时', {
                confirmButtonText: '跳转登录页面',
                callback: action => {
                    localStorage.clear();
                    window.location.href = '#/login';
                }
            })
        }
        return Promise.reject(error)
    }
)

export default {
    /*获取Banner列表(缓存) */
    async get_banners_list({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/bannersList',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },
    
    /*获取企业信息资料(缓存) */
    async get_enterprises_information({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/enterprises',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },

    /*获取新闻中心信息(缓存) */
    async get_news_information({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/news',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },

    /*获取新闻中心详情(缓存) */
    async get_news_detail({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/newsDetail',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },

    /*获取线下课程列表(缓存) */
    async get_course_list({ commit, state }, params) {
        return await axios({
            url: state.ip + 'course/courseList',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },

    /*获取线下课程详情(缓存) */
    async get_course_detail({ commit, state }, params) {
        return await axios({
            url: state.ip + 'course/courseDetail',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },

    /*获取推荐线下课程列表(缓存) */
    async get_recommend_course({ commit, state }, params) {
        return await axios({
            url: state.ip + 'course/recommendCourseList',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },

    /*获取解决客户方案数据 */
    async get_solutionList({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/solution',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },

    /*获取合作客户数据 */
    async get_cooperative({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/cooperative',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },

    /*获取公司数据 */
    async get_contactUs({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/contactUs',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },

    /*获取底部数据栏 */
    async get_footerInfo({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/manyinfo',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },

    /* 获取联系我们页面数据 */
    async get_contarctUsInfo({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/aboutus/',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },

    /* 获取产品中心页面数据 */
    async get_productInfo({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/products/',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },

    /* 获取产品中心详情页面数据 */
    async get_productDetailInfo({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/proDetail/',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },

    /* 获取发展历程数据 */
    async get_historyInfo({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/history/',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    }
}